import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {calendarDate} from 'shared/tools';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';
import _ from 'lodash';

class PayrollUpload extends DomainObject {
  id;
  createdAt;
  payrollFile;

  _relations = {
    payrollFile: AttachedDocument
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      createdAt: observable,
      payrollFile: observable,
      hasFiles: computed,
      dateView: computed,
      payrollFiles: computed
    });

    this.merge(other);
  }

  get hasFiles() {
    return !_.isEmpty(this.payrollFiles);
  }

  get dateView() {
    return calendarDate(this.createdAt);
  }

  get payrollFiles() {
    if (!this.payrollFile) return observable([]);

    return observable([this.payrollFile]);
  }

  set payrollFiles(value) {
    if (_.isEmpty(value)) {
      this.payrollFile = null;
    } else {
      this.payrollFile = value[0];
    }
  }
}

export default PayrollUpload;
